<template>
  <div>
    <v-app-bar app color="primary" dark>
      <div class="d-flex align-center">Template One</div>
      <v-spacer></v-spacer>
    </v-app-bar>

    <v-navigation-drawer app right permanent width="500">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title">
            Global Image Properties
          </v-list-item-title>
          <v-list-item-subtitle
            >Change default creative properties below</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-container>
        <v-row>
          <v-col col="12" class="p-2">
            <v-expansion-panels multiple>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  Canvas Options
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-text-field
                    v-model="formInput.campaignId"
                    label="Campaign ID"
                  />
                  <v-checkbox
                    disabled
                    v-model="formInput.compression"
                    label="Compress files?"
                    color="red darken-3"
                    hide-details
                  ></v-checkbox>
                  <v-radio-group v-model="formInput.canvas.fileType">
                    <template v-slot:label>
                      <strong>File Type</strong>
                    </template>
                    <v-radio
                      disabled
                      v-for="n in options.fileType"
                      :key="n.value"
                      :label="`${n.text}`"
                      :value="n.value"
                    ></v-radio>
                  </v-radio-group>
                  <v-color-picker
                    dot-size="25"
                    hide-mode-switch
                    mode="hexa"
                    swatches-max-height="158"
                    v-model="formInput.canvas.backgroundColor"
                  ></v-color-picker>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  Background Image Options
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-slider
                    v-model="formInput.backgroundImage.opacity"
                    label="Opacity"
                    thumb-label
                    max="1"
                    min="0"
                    step="0.1"
                  ></v-slider>
                  <v-file-input
                    truncate-length="25"
                    show-size
                    label="Background Image"
                    v-model="formInput.backgroundImage.imageAsset"
                  ></v-file-input>

                  <v-radio-group
                    v-model="formInput.backgroundImage.imagePosition"
                  >
                    <template v-slot:label>
                      <strong>Image Position</strong>
                    </template>
                    <v-radio
                      v-for="n in options.imagePosition"
                      :key="n.value"
                      :label="`${n.text}`"
                      :value="n.value"
                    ></v-radio>
                  </v-radio-group>
                  <div
                    v-if="formInput.backgroundImage.imagePosition == 'align'"
                  >
                    <v-radio-group
                      v-model="formInput.backgroundImage.imageAlignH"
                    >
                      <template v-slot:label>
                        <strong>Horizontal Alignment</strong>
                      </template>
                      <v-radio
                        v-for="n in options.imageAlignH"
                        :key="n.value"
                        :label="`${n.text}`"
                        :value="n.value"
                      ></v-radio>
                    </v-radio-group>
                    <v-radio-group
                      v-model="formInput.backgroundImage.imageAlignV"
                    >
                      <template v-slot:label>
                        <strong>Vertical Alignment</strong>
                      </template>
                      <v-radio
                        v-for="n in options.imageAlignV"
                        :key="n.value"
                        :label="`${n.text}`"
                        :value="n.value"
                      ></v-radio>
                    </v-radio-group>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header>
                  Logo Options
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-slider
                    v-model="formInput.logoImage.opacity"
                    label="Opacity"
                    thumb-label
                    max="1"
                    min="0"
                    step="0.1"
                  ></v-slider>
                  <v-file-input
                    truncate-length="25"
                    show-size
                    label="Logo Image"
                    v-model="formInput.logoImage.imageAsset"
                  ></v-file-input>
                  <v-radio-group v-model="formInput.logoImage.imagePosition">
                    <template v-slot:label>
                      <strong>Image Position</strong>
                    </template>
                    <v-radio
                      v-for="n in options.imagePosition"
                      :key="n.value"
                      :label="`${n.text}`"
                      :value="n.value"
                    ></v-radio>
                  </v-radio-group>
                  <div v-if="formInput.logoImage.imagePosition == 'align'">
                    <v-radio-group v-model="formInput.logoImage.imageAlignH">
                      <template v-slot:label>
                        <strong>Horizontal Alignment</strong>
                      </template>
                      <v-radio
                        v-for="n in options.imageAlignH"
                        :key="n.value"
                        :label="`${n.text}`"
                        :value="n.value"
                      ></v-radio>
                    </v-radio-group>
                    <v-radio-group v-model="formInput.logoImage.imageAlignV">
                      <template v-slot:label>
                        <strong>Vertical Alignment</strong>
                      </template>
                      <v-radio
                        v-for="n in options.imageAlignV"
                        :key="n.value"
                        :label="`${n.text}`"
                        :value="n.value"
                      ></v-radio>
                    </v-radio-group>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </v-container>

      <template v-slot:append>
        <v-container>
          <v-row align="center">
            <v-col cols="6">
              <v-btn
                color="error"
                large
                block
                @click="triggerGenerateAll"
                :loading="btnGenerateLoading"
                ><v-icon left> mdi-lightning-bolt </v-icon> Generate
                Images</v-btn
              >
            </v-col>
            <v-col class="d-flex" cols="6">
              <v-btn
                large
                block
                @click="downloadImages"
                :disabled="generatedImageList.length == 0"
                ><v-icon left> mdi-download </v-icon> Download All</v-btn
              >
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col class="d-flex" cols="12"> </v-col>
          </v-row>
        </v-container>
      </template>
    </v-navigation-drawer>

    <v-container>
      <v-row>
        <v-col cols="12" class="mb-4">
          <div
            v-if="generatedImageList.length != 0 && !btnGenerateLoading"
            class="grid-wrapper"
          >
            <ad-unit-preview
              v-for="image in generatedImageList"
              :key="image.id"
              :image-url="image.retinaThumbnailUrl"
              :image-full-url="image.imageUrl"
              :metadata="image.metadata"
              :file-name="image.fileName"
              :width="image.width"
              :height="image.height"
              :campaign-id="formInput.campaignId"
            ></ad-unit-preview>

            <ad-unit-preview
              v-for="image in generatedMockupList"
              :key="image.id"
              :image-url="image.retinaThumbnailUrl"
              :image-full-url="image.imageUrl"
              :metadata="image.metadata"
              :file-name="image.fileName"
              :width="image.width"
              :height="image.height"
              :campaign-id="formInput.campaignId"
            ></ad-unit-preview>
            <!-- pass in loading state -->
          </div>
          <div v-else-if="btnGenerateLoading">
            <v-skeleton-loader
              class="mx-auto"
              max-width="300"
              type="card"
            ></v-skeleton-loader>
          </div>
          <div v-else>
            <!-- <ad-unit-preview
              v-for="image in creativePreviews"
              :key="image.label"
              :width="image.width"
              :height="image.height"
            ></ad-unit-preview> -->

            <ad-unit-preview
              v-for="image in defaultImageList"
              :key="image.id"
              :image-url="image.thumbnail"
              :metadata="image.name"
            ></ad-unit-preview>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
// cro - Crop the image to fill the container leaving no empty space. This option is useful when the image size and aspect ratio is not much different from its container and you need to cut automatically a bit of space on the side(s).
// ai_face - detect face(s) on the image and crop intelligently so that faces are always visible.
// cov - cover container by scaling the image to the smallest possible size to fill the container, leaving no empty space. If the proportions of the background differ from the element, the image is cropped either vertically or horizontally.
// align - Align image inside its container. Provide this parameter and then use the imageAlignH and imageAlignV for exact positioning horizontally and vertically
import store from '@/store'
import AdUnitPreview from '@/components/AdUnitPreview.vue'

export default {
  name: 'TemplateOne',
  components: {
    AdUnitPreview,
  },
  data: () => ({
    // states
    btnGenerateLoading: false,
    // This is what get's displayed
    // creativePreviews: store.getters.ratios,
    // images
    defaultImageList: store.getters.defaultPreview,
    generatedImageList: [],
    generatedMockupList: [],
    options: {
      fileType: [
        {
          text: 'PNG',
          value: 'png',
        },
        {
          text: 'JPEG',
          value: 'jpg',
        },
      ],
      imagePosition: [
        {
          text: 'Centered (Default)',
          value: null,
        },
        {
          text: 'Crop to fit',
          value: 'cro',
        },
        {
          text: 'AI Face Detection',
          value: 'ai_face',
        },
        {
          text: 'Cover',
          value: 'cov',
        },
        {
          text: 'Align',
          value: 'align',
        },
      ],
      imageAlignH: [
        {
          text: 'Left',
          value: 'left',
        },
        {
          text: 'Center',
          value: 'center',
        },
        {
          text: 'Right',
          value: 'right',
        },
        {
          text: 'Fill Height',
          value: 'full',
        },
      ],
      imageAlignV: [
        {
          text: 'Top',
          value: 'top',
        },
        {
          text: 'Center',
          value: 'center',
        },
        {
          text: 'Bottom',
          value: 'bottom',
        },
        {
          text: 'Fill Width',
          value: 'full',
        },
      ],
    },
    formInput: {
      campaignId: '',
      compression: false,
      canvas: {
        backgroundColor: null,
        fileType: 'png',
      },
      backgroundImage: {
        imagePosition: null,
        imageAlignH: null,
        imageAlignV: null,
        imageAsset: null,
        imageUrl: null, // method UploadFile()
        opacity: 1,
      },
      logoImage: {
        imagePosition: null,
        imageAlignH: null,
        imageAlignV: null,
        imageAsset: null,
        imageUrl: null, // method UploadFile()
        opacity: 1,
      },
    },
  }),

  computed: {
    imagePreviewList() {
      return this.defaultImageList
    },
    generatorParams() {
      return [
        {
          name: 'canvas',
          backgroundColor: this.formInput.canvas.backgroundColor
            ? this.formInput.canvas.backgroundColor.hex
            : null,
        },
        {
          name: 'backgroundImage',
          imageUrl: this.formInput.backgroundImage.imageUrl,
          borderColor: 'none',
          borderWidth: '0',
          borderRadius: '0',
          opacity: parseInt(this.formInput.backgroundImage.opacity),
          imagePosition: this.formInput.backgroundImage.imagePosition,
          imageAlignH: this.formInput.backgroundImage.imageAlignH,
          imageAlignV: this.formInput.backgroundImage.imageAlignV,
        },
        {
          name: 'logo',
          imageUrl: this.formInput.logoImage.imageUrl,
          borderColor: 'none',
          borderWidth: '0',
          borderRadius: '0',
          opacity: parseInt(this.formInput.logoImage.opacity),
          imagePosition: this.formInput.logoImage.imagePosition,
          imageAlignH: this.formInput.logoImage.imageAlignH,
          imageAlignV: this.formInput.logoImage.imageAlignV,
        },
      ]
    },
  },

  watch: {
    async generatedImageList() {
      await this.triggerGenerateMockup()
      this.btnGenerateLoading = false
    },
  },

  methods: {
    async triggerGenerateAll() {
      this.btnGenerateLoading = true
      await this.uploadImages()
      console.log('generatorparams', this.generatorParams)
      this.generatedImageList = await store.dispatch(
        'generateAll',
        this.generatorParams,
      )
    },
    async triggerGenerateMockup() {
      // Soon this will be a list of ID's
      const mockupTemplateId = 'ddcbf30d50' // Only uses 60:9
      // Find 60:9 Image from the Generated List
      const imageUrl = this.generatedImageList.filter(ctx =>
        'd38966dc63' === ctx.templateId ? ctx.imageUrl : '',
      )[0].imageUrl
      console.log(`Generated Image for Mockup: ${imageUrl}`)

      const metadata =
        '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'
      // 'AutoGeneratorUI - Baseball Clash Mockup'
      const params = [
        {
          name: 'banner_1',
          imageUrl,
        },
        {
          name: 'banner_2',
          imageUrl,
        },
        {
          name: 'banner_3',
          imageUrl,
        },
      ]
      let generatedMockupImage = await store.dispatch('generateImage', {
        templateID: mockupTemplateId,
        metadata,
        params,
      })
      this.generatedMockupList.push(generatedMockupImage)
    },
    clearGeneratedImages() {
      this.generatedImageList = []
    },
    downloadImages() {
      for (const image of this.generatedImageList) {
        let campaignId = this.formInput.campaignId
          ? this.formInput.campaignId + '-'
          : ''
        let fileName = `${campaignId}${image.width}x${image.height}-${image.fileName}`
        let imageUrl = image.imageUrl
        store.dispatch('downloadImage', { imageUrl, fileName })
      }
    },
    async uploadImages() {
      // The workspace where images get uploaded to in DynaPictures
      const workspaceId = '0da457bca1' // Template_1_BasicLogo
      let backgroundImageUrl = null
      let logoImageUrl = null

      // Upload Background Image
      if (this.formInput.backgroundImage.imageAsset) {
        await store
          .dispatch('uploadImage', {
            workspaceId,
            file: this.formInput.backgroundImage.imageAsset,
          })
          .then(file => {
            backgroundImageUrl = file.url
            console.log(file.uuid)
          })
      }
      // Upload Logo Image
      if (this.formInput.logoImage.imageAsset) {
        await store
          .dispatch('uploadImage', {
            workspaceId,
            file: this.formInput.logoImage.imageAsset,
          })
          .then(file => {
            logoImageUrl = file.url
            console.log(file.uuid)
          })
      }

      this.formInput.backgroundImage.imageUrl = backgroundImageUrl
      this.formInput.logoImage.imageUrl = logoImageUrl
      console.log(backgroundImageUrl, logoImageUrl)
    },
  },
}
</script>

<style lang="scss" scoped>
// .grid-wrapper > div {
//   display: flex;
//   justify-content: center;
//   align-items: center;
// }
// .grid-wrapper > div > img {
//   width: 100%;
//   height: 100%;
//   object-fit: cover;
//   border-radius: 5px;
// }

// .grid-wrapper {
//   display: grid;
//   grid-gap: 10px;
//   grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
//   grid-auto-rows: 300px;
//   grid-auto-flow: dense;
// }
// .grid-wrapper .wide {
//   grid-column: span 2;
// }
// .grid-wrapper .tall {
//   grid-row: span 2;
// }
// .grid-wrapper .big {
//   grid-column: span 2;
//   grid-row: span 2;
// }
</style>
